import React from 'react';
import { useNavigate } from 'react-router-dom';
import titlestar from '../../../../assets/images/institute/title-star.svg';
import feature_one_desktop from '../../../../assets/images/institute/feature_one_desktop.png';
import instituteHero from '../../../../assets/images/institute/institute-hero.png';
import pinkdiamond from '../../../../assets/images/institute/pinkdiamond.png';
import feature2Img from '../../../../assets/images/institute/feature2Img.png';
import discountImage from '../../../../assets/images/institute/discountImage.png';
import bankImageP from '../../../../assets/images/institute/bankImageP.png';
import mobileDashboard from '../../../../assets/images/institute/mobileDashboard.png';
import feature_four_desktop from '../../../../assets/images/institute/feature_four_desktop.png';
import classes from './FeeManagement.module.scss';
import { CustomButton, CustomImage } from '../../../atoms';

const FeeManagement = () => {
    const navigate = useNavigate();
    return (
        <div className={classes.FeeManagement}>
            <div className={classes.FeeManagement__HeaderSection}>
                <h2
                    className={classes.FeeManagement__Header}>
                    Introducing{' '}
                    <span className={classes.FeeManagement__YouText}>ARC</span>
                </h2>
                <div className={classes.FeeManagement__Description}>A thoughtfully designed SAAS platform to cater to the needs of your educational institute, ranging from seamless fee collection to parent communication</div>
                <div>
                    <CustomButton
                        className={classes.FeeManagement__ScheduleBtn}
                        onClick={() => navigate('/contact')}
                        text='Schedule demo'
                    >
                    </CustomButton>
                </div>
            </div>
            <div className={classes.ImageWrapper}>
                <img className={classes.HeroImage} src={feature_one_desktop} alt="feemanagemnt" />
            </div>
            <div className={`${classes.FeatureWrapper} ${classes.BgGrayColor}`}>
                <div className={classes.FeatureWrapper__Container}>
                    <div className={classes.FeatureWrapper__LeftSection}>
                        <div className={classes.FeatureWrapper__TitleWrapper}>
                            <img className={classes.FeatureWrapper__Star} src={titlestar} alt="star icon" />
                            <p className={classes.FeatureWrapper__Title}>FEATURE 1</p>
                        </div>
                        <div className={classes.FeatureWrapper__HeadingWrapper}>
                            <h2 className={classes.FeatureWrapper__GradientText}>User-friendly dashboard {' '}</h2>
                            <h2 className={classes.FeatureWrapper__NormalText}>to analyse your collection summary</h2>
                        </div>
                    </div>
                    <div className={classes.FeatureWrapper__RightSection}>
                        <div className={classes.FeatureWrapper__DiscriptionWrapper}>
                            Arc lets you track and analyse your fee collection summary in a simplified eagle-eyed dashboard.
                        </div>
                    </div>
                </div>
                <div className={classes.HeroImageWrapper}>
                    <CustomImage
                        title='feemanagement'
                        className='img-fluid'
                        images={[
                            {
                                media: '468',
                                src: instituteHero,
                            }
                        ]}
                        lazy={false}
                        defaultImg={feature_one_desktop}
                    />
                </div>
            </div>

            <div className=' featurekeyBenefit keyBenefit'>
                <div className='container'>
                    <div className='row'>
                        <p className='section__label blue'>KEY BENEFITS</p>
                    </div>
                    <div className='row'>
                        <div className='col-lg-6'>
                            <div className='feature-box-1'>
                                <div className='d-flex align-items-start'>
                                    <img
                                        src={pinkdiamond}
                                        style={{
                                            width: '27px',
                                            marginRight: '10px',
                                        }}
                                    />
                                    <p className='text-left feature-box-text'>
                                        <span className='text--bold'>
                                            Access comprehensive analytics
                                            and insights
                                        </span>{' '}
                                        on our dashboard
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <div className='feature-box-1'>
                                <div className='d-flex align-items-start'>
                                    <img
                                        src={pinkdiamond}
                                        style={{
                                            width: '27px',
                                            marginRight: '10px',
                                        }}
                                    />

                                    <p className='text-left feature-box-text'>
                                        <span className='text--bold'>
                                            Keep long-term, digital records
                                        </span>{' '}
                                        of past collection summaries.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={`${classes.FeatureWrapper} ${classes.BgGrayColor}`}>
                <div className={classes.FeatureWrapper__Container}>
                    <div className={classes.FeatureWrapper__LeftSection}>
                        <div className={classes.FeatureWrapper__TitleWrapper}>
                            <img className={classes.FeatureWrapper__Star} src={titlestar} alt="star icon" />
                            <p className={classes.FeatureWrapper__Title}>FEATURE 2</p>
                        </div>
                        <div className={classes.FeatureWrapper__HeadingWrapper}>
                            <h2 className={classes.FeatureWrapper__GradientText}>Personalise {' '}</h2>
                            <h2 className={classes.FeatureWrapper__NormalText}>fee payment links for parents</h2>
                        </div>
                    </div>
                    <div className={classes.FeatureWrapper__RightSection}>
                        <div className={classes.FeatureWrapper__DiscriptionWrapper}>
                            Send custom payment links to parents & communicate via WhatsApp or other available options.
                        </div>
                    </div>
                </div>
                <div className='hero__banner useFriendlyImage'>
                    <img
                        className='img-fluid  '
                        src={feature2Img}
                        alt='parent hero'
                    />
                </div>
            </div>
            <div className='keyBenefit'>
                <div className='container'>
                    <div className='row'>
                        <p className='section__label blue'>KEY BENEFITS</p>
                    </div>
                    <div className='row'>
                        <div className='col-lg-6'>
                            <div className='feature-box-1'>
                                <div className='d-flex align-items-start'>
                                    <img
                                        src={pinkdiamond}
                                        style={{
                                            width: '27px',
                                            marginRight: '10px',
                                        }}
                                    />

                                    <p className='text-left feature-box-text'>
                                        Communicate with parents instantly
                                        <span className='text--bold'>
                                            via WhatsApp, email, and SMS.
                                        </span>{' '}
                                        on our dashboard
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <div className='feature-box-1'>
                                <div className='d-flex align-items-start'>
                                    <img
                                        src={pinkdiamond}
                                        style={{
                                            width: '27px',
                                            marginRight: '10px',
                                        }}
                                    />

                                    <p className='text-left feature-box-text'>
                                        Get the flexibility of{' '}
                                        <span className='text--bold'>
                                            sending custom payment links
                                        </span>{' '}
                                        to each parent based on their fee
                                        structure of past collection
                                        summaries.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`${classes.FeatureWrapper} ${classes.BgGrayColor}`}>
                <div className={classes.FeatureWrapper__Container}>
                    <div className={classes.FeatureWrapper__LeftSection}>
                        <div className={classes.FeatureWrapper__TitleWrapper}>
                            <img className={classes.FeatureWrapper__Star} src={titlestar} alt="star icon" />
                            <p className={classes.FeatureWrapper__Title}>FEATURE 3</p>
                        </div>
                        <div className={classes.FeatureWrapper__HeadingWrapper}>
                            <h2 className={classes.FeatureWrapper__GradientText}>Smart payment solutions {' '}</h2>
                            <h2 className={classes.FeatureWrapper__NormalText}>for complex fee structures</h2>
                        </div>
                    </div>
                    <div className={classes.FeatureWrapper__RightSection}>
                        <div className={classes.FeatureWrapper__DiscriptionWrapper}>
                            Customize and Collect fees at an individual parent level using our super configurable platform.
                        </div>
                    </div>
                </div>
                <div className={classes.FeatureWrapper__KeyBenefits}>
                    <div
                        className='row keyContainer'
                    >
                        <p
                            className='section__label keyTitle blue'
                            style={{
                                fontSize: '22px',
                            }}
                        >
                            KEY BENEFITS
                        </p>
                    </div>
                    <div
                        className='row keyRow'
                        style={{
                            marginTop: '30px',
                        }}
                    >
                        <div className='col-lg-6'>
                            <div className='row'>
                                <div className='col-lg-12'>
                                    <img
                                        src={discountImage}
                                        className='discountImage'
                                    />
                                </div>
                                <div className='col-lg-12 mg--20'>
                                    <h6 className='discount-desc'>
                                        Apply{' '}
                                        <span className='text--bold'>
                                            fixed or one-time fee discounts
                                        </span>{' '}
                                        to individuals or groups of selected
                                        students
                                    </h6>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <div className='row'>
                                <div className='col-lg-12'>
                                    <img
                                        src={bankImageP}
                                        className='discountImage'
                                    />
                                </div>
                                <div className='col-lg-12 mg--20'>
                                    <h6 className='discount-desc'>
                                        Create different types of fee
                                        headers and
                                        <span className='text--bold'>
                                            {' '}
                                            receive fees in multiple bank
                                            accounts{' '}
                                        </span>
                                        based on fee headers.
                                    </h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={`${classes.FeatureWrapper} ${classes.BgWhiteColor}`}>
                <div className={classes.FeatureWrapper__Container}>
                    <div className={classes.FeatureWrapper__LeftSection}>
                        <div className={classes.FeatureWrapper__TitleWrapper}>
                            <img className={classes.FeatureWrapper__Star} src={titlestar} alt="star icon" />
                            <p className={classes.FeatureWrapper__Title}>FEATURE 4</p>
                        </div>
                        <div className={classes.FeatureWrapper__HeadingWrapper}>
                            <h2><span className={classes.FeatureWrapper__NormalText}>Extract{' '}</span>
                                <span className={classes.FeatureWrapper__GradientText}>customisable reports {' '}</span></h2>
                            <h2 className={classes.FeatureWrapper__NormalText}>for your institute’s fee-collection</h2>
                        </div>
                    </div>
                    <div className={classes.FeatureWrapper__RightSection}>
                        <div className={classes.FeatureWrapper__DiscriptionWrapper}>
                            Refer to pre existing reports on the ARC dashboard to constantly keep track of your collections.
                        </div>
                    </div>
                </div>
                <div className={classes.HeroImageWrapper}>
                    <CustomImage
                        title='feemanagementfour-img'
                        className='img-fluid'
                        images={[
                            {
                                media: '468',
                                src: mobileDashboard,
                            }
                        ]}
                        lazy={false}
                        defaultImg={feature_four_desktop}
                    />
                </div>
            </div>
            <div className='bg--lightGray keyBenefit'>
                <div className='container'>
                    <div className='row'>
                        <p
                            className='section__label blue mb-3'
                            style={{
                                fontSize: '22px',
                            }}
                        >
                            KEY BENEFITS
                        </p>
                    </div>
                    <div className='row'>
                        <div className='col-lg-6'>
                            <div className='feature-box-1'>
                                <div className='d-flex align-items-start'>
                                    <img
                                        src={pinkdiamond}
                                        style={{
                                            marginRight: '10px',
                                            width: '27px',
                                        }}
                                    />

                                    <p className='text-left feature-box-text'>
                                        <span className='text--bold'>
                                            {' '}
                                            Create custom reports
                                        </span>{' '}
                                        only with specific variables that
                                        you would like to highlight.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <div className='feature-box-1'>
                                <div className='d-flex align-items-start'>
                                    <img
                                        src={pinkdiamond}
                                        style={{
                                            marginRight: '10px',
                                            width: '27px',
                                        }}
                                    />

                                    <p className='text-left feature-box-text'>
                                        Use our{' '}
                                        <span className='text--bold'>
                                            pre-defined{' '}
                                        </span>
                                        report formats to stay up to date
                                        with all collection-related data.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FeeManagement